const imageCompression = (await import("browser-image-compression")).default;
import { getSupabase } from "../lib/supabase";

export async function uploadCaseStudyImage(file) {
  // Compress image
  const compressed = await imageCompression(file, {
    maxSizeMB: 0.6,
    maxWidthOrHeight: 1800,
    useWebWorker: true,
  });

  // Generate path
  const ext = compressed.name.split(".").pop();
  const filePath = `case-studies/${crypto.randomUUID()}.${ext}`;

  const supabase = await getSupabase();

  // Upload to bucket
  const { error } = await supabase.storage
    .from("insights") // Reusing the same bucket but isolated in case-studies folder
    .upload(filePath, compressed, {
      cacheControl: "3600",
      upsert: false,
      contentType: compressed.type,
    });

  if (error) throw error;

  return filePath;
}
